import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import type { MyRouterContext } from './routes/__root'

// Get base path from Vite config (set via VITE_BASE_PATH env var in Docker)
// Remove trailing slash for router basepath
const basepath = (import.meta.env.BASE_URL || '/').replace(/\/$/, '') || '/'

export const router = createRouter({
  routeTree,
  basepath,
  context: { queryClient: undefined!, auth: undefined! } as MyRouterContext,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
})

// Register things for typesafety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
